var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["question-review-container", "level-" + _vm.level] },
    [
      _c(
        "div",
        {
          staticClass: "row single-quesion-box",
          style: { marginLeft: _vm.level * 30 + "px" }
        },
        [
          _c("div", { staticClass: "col-md-12" }, [
            _c("strong", [
              _vm.level > 0
                ? _c("span", { staticStyle: { color: "#999" } }, [
                    _vm._v("↳ Follow-up ")
                  ])
                : _vm._e(),
              _vm._v(
                "\n        Question " + _vm._s(_vm.questionNumber) + ":\n      "
              )
            ]),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.question.question) }
            })
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c("strong", [_vm._v("Answer Type: ")]),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.getAnswerType(_vm.question.questionType))
              }
            })
          ]),
          _c("br"),
          _vm.question.questionType != "TEXT"
            ? _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "ul",
                  { staticClass: "answer-list" },
                  _vm._l(_vm.question.answers, function(answer, ai) {
                    return _c("li", { key: ai, staticClass: "answer-item" }, [
                      _c("div", { staticClass: "answer-text" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(answer.answerOption) }
                        }),
                        answer.followUpQuestions &&
                        answer.followUpQuestions.length > 0
                          ? _c("span", { staticClass: "has-followup-badge" }, [
                              _vm._v(
                                "\n              (has follow-up)\n            "
                              )
                            ])
                          : _vm._e()
                      ]),
                      answer.followUpQuestions &&
                      answer.followUpQuestions.length > 0
                        ? _c(
                            "div",
                            { staticClass: "followup-container" },
                            _vm._l(answer.followUpQuestions, function(
                              followUpQuestion,
                              fqi
                            ) {
                              return _c("QuestionReview", {
                                key: "followup-" + ai + "-" + fqi,
                                attrs: {
                                  question: followUpQuestion,
                                  questionNumber: fqi + 1,
                                  level: _vm.level + 1
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }